import { render, staticRenderFns } from "./ManagerShiftsRegistryScrollFixTable.vue?vue&type=template&id=04fa6c58&lang=pug&"
import script from "./ManagerShiftsRegistryScrollFixTable.vue?vue&type=script&lang=js&"
export * from "./ManagerShiftsRegistryScrollFixTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports